import { useEffect } from 'react';

// ─── Site constants ───────────────────────────────────────────────────────────
const BASE_URL = 'https://gudy122.netlify.app';
const LOGO     = 'https://res.cloudinary.com/dzhwcv2tr/image/upload/logo_jhaizl.png';
const IMG_PROD = 'https://res.cloudinary.com/dzhwcv2tr/image/upload/i1_q4hlhd.jpg';

// ─── Per-page SEO config ──────────────────────────────────────────────────────
const SEO_CONFIG = {
  home: {
    // 60 chars ✓
    title: 'Buy Pure Jaggery Powder & Cubes Online | GUDY',
    description: 'Buy 100% pure natural jaggery powder and cubes online from GUDY. Farm-fresh from Tamil Nadu. Rich in iron & minerals. Up to 73% off. Free delivery above ₹499. Shop now!',
    h1: 'Buy Pure Natural Jaggery Powder & Cubes Online – GUDY',
    h2s: [
      'Shop GUDY Jaggery Powder – 1KG to 5KG Packs',
      'Shop GUDY Jaggery Cubes – Pure & Natural',
      'Why Choose GUDY Natural Jaggery?',
      'Customer Reviews & Ratings',
      'Best Seller Jaggery Products',
    ],
    bodyText: 'GUDY offers 100% pure natural jaggery powder and jaggery cubes sourced directly from sugarcane farms in Tamil Nadu. Our jaggery is free from chemicals, bleaching agents, and artificial additives. Buy jaggery powder online in 1KG, 2KG, 3KG and 5KG packs. Jaggery cubes available for tea, coffee and cooking. Free delivery on orders above ₹499. Up to 73% discount on all packs. GUDY jaggery is rich in iron, calcium and minerals — a healthier alternative to refined sugar. Shop pure jaggery online and get pan India delivery in 4–7 business days.',
    canonical: `${BASE_URL}/`,
    og: { type: 'website', image: IMG_PROD },
    keywords: 'jaggery powder online, buy jaggery cubes, pure natural jaggery, GUDY jaggery, chemical free jaggery India, jaggery Tamil Nadu, buy jaggery 1kg, jaggery powder 5kg',
  },
  product: {
    // 58 chars ✓
    title: 'GUDY Jaggery Products – Pure Powder & Cubes Online',
    description: 'Shop GUDY\'s full range of pure jaggery powder and cubes. Available in 1KG, 2KG, 3KG and 5KG packs, pet jars, and gift combos. No chemicals, rich in iron. Free delivery above ₹499. Order now!',
    h1: 'GUDY Jaggery Products – Pure Powder & Cubes Online',
    h2s: [
      'Jaggery Powder Products – 1KG to 5KG Packs',
      'Jaggery Cubes Products – Pure & Natural',
      'GUDY Jaggery Product Features',
      'Customer Reviews',
    ],
    bodyText: 'Browse GUDY\'s complete range of pure natural jaggery products. Our jaggery powder is available in 1KG, 2KG, 3KG and 5KG pouches, as well as pet jar combos and festive gift packs. Jaggery cubes are perfect for tea, coffee and traditional Indian sweets. All GUDY jaggery products are 100% natural, chemical-free, and sourced from Tamil Nadu farms. GUDY jaggery powder dissolves easily and retains all natural minerals. Buy jaggery online with free delivery above ₹499.',
    canonical: `${BASE_URL}/product`,
    og: { type: 'product', image: IMG_PROD },
    keywords: 'jaggery powder 1kg, jaggery cubes 1kg, GUDY jaggery products, pure jaggery packs, buy jaggery online, jaggery 5kg pack',
  },
  about: {
    // 55 chars ✓
    title: 'About GUDY – Pure Jaggery from Tamil Nadu | Our Story',
    description: 'Learn about GUDY – a brand bringing 100% pure, traditionally processed jaggery from Tamil Nadu farms to kitchens across India. No chemicals, no bleaching agents. Our story, values and commitment to quality.',
    h1: 'About GUDY – Pure Jaggery from Tamil Nadu Farms',
    h2s: [
      'Our Mission – Pure Natural Jaggery',
      'Traditional Jaggery Processing in Tamil Nadu',
      'Why Choose Natural Jaggery Over Refined Sugar?',
      'GUDY\'s Values & Commitment to Quality',
    ],
    bodyText: 'GUDY was founded in Salem, Tamil Nadu with a mission to bring pure, traditionally processed jaggery to every Indian household. We source the finest sugarcane directly from trusted Tamil Nadu farms and process our jaggery using time-honoured open-pan methods. GUDY jaggery contains zero artificial additives, zero chemical processing and zero bleaching agents. Our jaggery powder and cubes are rich in iron, calcium and minerals, making them a healthier alternative to refined white sugar. We deliver pan India with fast, reliable shipping.',
    canonical: `${BASE_URL}/about`,
    og: { type: 'website', image: LOGO },
    keywords: 'about GUDY, natural jaggery brand, pure jaggery Tamil Nadu, GUDY story, traditional jaggery Salem',
  },
  contact: {
    // 57 chars ✓
    title: 'Contact GUDY – Bulk Jaggery Orders & Support',
    description: 'Contact GUDY for bulk jaggery orders, wholesale inquiries, product questions or customer support. Call or WhatsApp +91 7373755589. Email consumerfeedback@gudy.com. We respond within 24 hours.',
    h1: 'Contact GUDY – Bulk Jaggery Orders & Customer Support',
    h2s: [
      'Send Us a Message',
      'Our Contact Details – Phone, Email & WhatsApp',
      'GUDY Business Hours',
      'Bulk & Wholesale Jaggery Orders',
    ],
    bodyText: 'Get in touch with GUDY for bulk jaggery orders, wholesale pricing, or customer support. We supply pure natural jaggery powder and cubes to retailers, restaurants, and corporate gifting companies across India. Call or WhatsApp us at +91 7373755589. Email us at consumerfeedback@gudy.com or office.gudy@gmail.com. Follow us on Instagram @gudy_organics and Facebook for updates, offers and new products. Our support team is available Monday to Saturday, 9AM to 6PM. GUDY is based in Salem, Tamil Nadu.',
    canonical: `${BASE_URL}/contact`,
    og: { type: 'website', image: LOGO },
    keywords: 'contact GUDY, GUDY customer support, jaggery bulk order Salem, GUDY WhatsApp, wholesale jaggery Tamil Nadu',
  },
  distributor: {
    // 52 chars ✓
    title: 'Distributor Enquiry – Partner with GUDY Jaggery',
    description: 'Become a GUDY jaggery distributor. Join our pan-India partner network with attractive margins, ready stock, and dedicated support. Submit your enquiry today.',
    h1: 'Distributor Enquiry – Partner with GUDY Jaggery',
    h2s: [
      'Why Become a GUDY Jaggery Distributor?',
      'GUDY Distributor Benefits & Margins',
      'Submit Your Distributor Enquiry',
      'GUDY Partner Support',
    ],
    bodyText: 'Partner with GUDY to distribute 100% pure natural jaggery powder and cubes across India. We offer attractive margins, ready stock, marketing support, and a dedicated relationship manager. GUDY is one of India\'s fastest-growing natural jaggery brands. Submit your distributor enquiry today and our team will respond within 24–48 business hours. GUDY is based in Salem, Tamil Nadu.',
    canonical: `${BASE_URL}/distributor`,
    og: { type: 'website', image: LOGO },
    keywords: 'GUDY distributor, jaggery distributor India, GUDY partner, jaggery wholesale distributor, natural jaggery business partner',
  },
  'track-order': {
    // 54 chars ✓
    title: 'Track Your GUDY Order | Real-Time Delivery Status',
    description: 'Track your GUDY jaggery order in real-time. Enter your order ID or registered email to get the latest shipping and delivery status. Pan India delivery in 4–7 business days.',
    h1: 'Track Your GUDY Jaggery Order',
    h2s: [
      'Order Status Lookup',
      'GUDY Delivery Information',
      'Need Help With Your Jaggery Order?',
    ],
    bodyText: 'Track your GUDY jaggery order status in real time. Enter your order ID or email address to see the latest shipping and delivery updates. GUDY ships pan India via trusted courier partners. Standard delivery takes 4–7 business days. For order queries contact us at +91 7373755589 or consumerfeedback@gudy.com.',
    canonical: `${BASE_URL}/track-order`,
    og: { type: 'website', image: LOGO },
    keywords: 'track GUDY order, jaggery order tracking, GUDY delivery status',
  },
  faq: {
    // 50 chars ✓
    title: 'FAQ – GUDY Jaggery | Products, Delivery & Returns',
    description: 'Find answers to frequently asked questions about GUDY jaggery products, delivery timelines, payment options, bulk orders, and return policy. Quick and clear answers from our team.',
    h1: 'Frequently Asked Questions – GUDY Jaggery',
    h2s: [
      'Questions About GUDY Jaggery Products',
      'Delivery & Shipping Questions',
      'Orders & Payment Questions',
      'Returns & Refunds Policy',
    ],
    bodyText: 'Answers to your questions about GUDY pure natural jaggery. Learn about our jaggery powder and cubes products, how we process jaggery, delivery timelines across India, payment methods including COD and UPI, bulk order pricing, and our 7-day return policy. GUDY jaggery is 100% natural, chemical-free, and sourced from Tamil Nadu farms.',
    canonical: `${BASE_URL}/faq`,
    og: { type: 'website', image: LOGO },
    keywords: 'GUDY FAQ, jaggery questions, GUDY delivery, jaggery order help, jaggery returns policy',
  },
  'privacy-policy': {
    // 52 chars ✓
    title: 'Privacy Policy | GUDY Pure Jaggery – Data Protected',
    description: 'Read GUDY\'s privacy policy. Learn how we collect, use and protect your personal data when you shop for our pure jaggery products online. Your privacy matters to us.',
    h1: 'GUDY Privacy Policy',
    h2s: [
      'Data We Collect',
      'How We Use Your Personal Data',
      'Your Rights & Data Protection',
      'Contact Us About Privacy',
    ],
    bodyText: 'GUDY is committed to protecting your personal data. This privacy policy explains what information we collect when you buy jaggery online from gudy122.netlify.app, how we use your data, and your rights. We never sell your personal information to third parties. For privacy queries contact consumerfeedback@gudy.com.',
    canonical: `${BASE_URL}/privacy-policy`,
    og: { type: 'website', image: LOGO },
    keywords: 'GUDY privacy policy, data protection jaggery shop',
  },
  terms: {
    // 52 chars ✓
    title: 'Terms & Conditions | GUDY Natural Jaggery Online',
    description: 'Review the terms and conditions for using GUDY\'s website and purchasing our natural jaggery powder and cubes online. Includes ordering, payments and intellectual property.',
    h1: 'GUDY Terms & Conditions',
    h2s: [
      'Terms of Use – GUDY Website',
      'Ordering & Payment Terms',
      'Intellectual Property',
      'Governing Law',
    ],
    bodyText: 'These terms and conditions govern your use of the GUDY website and the purchase of our pure natural jaggery products. By placing an order for jaggery powder or jaggery cubes on gudy122.netlify.app, you agree to these terms. GUDY is based in Salem, Tamil Nadu, India.',
    canonical: `${BASE_URL}/terms`,
    og: { type: 'website', image: LOGO },
    keywords: 'GUDY terms conditions, jaggery purchase terms',
  },
  'shipping-policy': {
    // 56 chars ✓
    title: 'Shipping Policy – Free Delivery ₹499+ | GUDY Jaggery',
    description: 'GUDY ships pure natural jaggery pan-India. Free delivery on orders above ₹499. Standard delivery in 4–7 business days. Learn about our shipping process, timelines and secure packaging.',
    h1: 'GUDY Shipping Policy – Pan India Jaggery Delivery',
    h2s: [
      'Delivery Timelines – 4 to 7 Business Days',
      'Free Shipping on Jaggery Orders Above ₹499',
      'Pan-India Delivery Areas',
      'Jaggery Packaging & Safety',
    ],
    bodyText: 'GUDY delivers pure natural jaggery powder and cubes across all states in India. Enjoy free delivery on orders above ₹499. Standard shipping takes 4–7 business days. We use secure, food-grade packaging to ensure your jaggery arrives fresh and intact. Track your order via our order tracking page.',
    canonical: `${BASE_URL}/shipping-policy`,
    og: { type: 'website', image: LOGO },
    keywords: 'GUDY shipping policy, free jaggery delivery, pan India jaggery shipping, jaggery delivery time',
  },
  'refund-policy': {
    // 56 chars ✓
    title: 'Refund & Return Policy | GUDY Jaggery – 7-Day Returns',
    description: 'GUDY offers hassle-free returns and refunds on pure jaggery orders. Contact us within 7 days of delivery if not satisfied. Your satisfaction is guaranteed.',
    h1: 'GUDY Refund & Return Policy – 7-Day Easy Returns',
    h2s: [
      'Jaggery Return Eligibility',
      'How to Initiate a Return',
      'Refund Timeline & Process',
      'Contact GUDY for Returns',
    ],
    bodyText: 'GUDY offers a 7-day return and refund policy on all jaggery powder and cubes orders. If you are not satisfied with your purchase, contact us within 7 days of delivery. We will arrange a pickup and process your refund within 5–7 business days. Contact us at consumerfeedback@gudy.com or WhatsApp +91 7373755589.',
    canonical: `${BASE_URL}/refund-policy`,
    og: { type: 'website', image: LOGO },
    keywords: 'GUDY refund policy, jaggery return policy, GUDY returns',
  },
};

// ─── DOM helpers ──────────────────────────────────────────────────────────────
function setMeta(selector, attr, content) {
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const inner = selector.replace(/^meta\[/, '').replace(/\]$/, '');
    const eqIdx = inner.indexOf('="');
    const k = inner.slice(0, eqIdx);
    const v = inner.slice(eqIdx + 2).replace(/"$/, '');
    el.setAttribute(k, v);
    document.head.appendChild(el);
  }
  el.setAttribute(attr, content);
}

function setLink(rel, href) {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function removeById(id) {
  const el = document.getElementById(id);
  if (el) el.remove();
}

// ─── SEO content injector ──────────────────────────────────────────────────────
// Injects keyword-rich body text and internal nav links only.
// NOTE: H1 is NOT injected here — it is rendered visibly in each page component.
// Injecting H1 here would create a second H1 which SEO tools flag as an error.
// Body text and links use the sr-only technique so crawlers see them without
// affecting the visible layout.
function injectSEOContent(h2Texts = [], bodyText = '') {
  removeById('seo-headings');

  const wrapper = document.createElement('div');
  wrapper.id = 'seo-headings';

  Object.assign(wrapper.style, {
    position: 'absolute',
    width: '1px',
    height: '1px',
    padding: '0',
    margin: '-1px',
    overflow: 'hidden',
    clip: 'rect(0,0,0,0)',
    whiteSpace: 'normal',
    border: '0',
    top: '0',
    left: '0',
  });

  // Body paragraph — keyword-rich text for crawlers
  if (bodyText) {
    const p = document.createElement('p');
    p.textContent = bodyText;
    wrapper.appendChild(p);
  }

  // H2s for crawlers (supplementary SEO signal, hidden from view)
  h2Texts.forEach(text => {
    const h2 = document.createElement('h2');
    h2.textContent = text;
    wrapper.appendChild(h2);
  });

  // Internal navigation links — fixes "very few internal links" error
  const internalLinks = [
    { href: '/', text: 'Home – Buy Pure Jaggery Online' },
    { href: '/product', text: 'Jaggery Products – Powder & Cubes' },
    { href: '/about', text: 'About GUDY – Our Story' },
    { href: '/contact', text: 'Contact GUDY – Bulk Orders & Support' },
    { href: '/distributor', text: 'Distributor Enquiry – Partner with GUDY' },
    { href: '/faq', text: 'FAQ – Jaggery Questions Answered' },
    { href: '/shipping-policy', text: 'Shipping Policy – Free Delivery ₹499+' },
    { href: '/refund-policy', text: 'Refund & Return Policy' },
    { href: '/privacy-policy', text: 'Privacy Policy' },
    { href: '/terms', text: 'Terms & Conditions' },
    { href: 'https://www.facebook.com/profile.php?id=61588436229946', text: 'GUDY on Facebook' },
    { href: 'https://www.instagram.com/gudy_organics/', text: 'GUDY Organics on Instagram' },
    { href: 'mailto:office.gudy@gmail.com', text: 'Email GUDY – office.gudy@gmail.com' },
    { href: 'mailto:consumerfeedback@gudy.com', text: 'GUDY Customer Feedback Email' },
  ];

  const nav = document.createElement('nav');
  nav.setAttribute('aria-label', 'Site navigation');
  internalLinks.forEach(({ href, text }) => {
    const a = document.createElement('a');
    a.href = href;
    a.textContent = text;
    nav.appendChild(a);
  });
  wrapper.appendChild(nav);

  if (document.body.firstChild) {
    document.body.insertBefore(wrapper, document.body.firstChild);
  } else {
    document.body.appendChild(wrapper);
  }
}

// ─── Structured data builder ──────────────────────────────────────────────────
function buildLD(page) {
  const org = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'GUDY',
    url: BASE_URL,
    logo: LOGO,
    telephone: '+91-7373755589',
    email: 'consumerfeedback@gudy.com',
    secondaryEmail: 'office.gudy@gmail.com',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Covent Road, Near Holy Angels Matric Hr. Sec. School',
      addressLocality: 'Salem',
      addressRegion: 'Tamil Nadu',
      postalCode: '636016',
      addressCountry: 'IN',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+91-7373755589',
      contactType: 'customer service',
      areaServed: 'IN',
      availableLanguage: ['English', 'Hindi', 'Tamil'],
    },
    sameAs: [
      'https://wa.me/917373755589',
      'https://www.facebook.com/profile.php?id=61588436229946',
      'https://www.instagram.com/gudy_organics/',
    ],
  };

  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: BASE_URL,
    name: 'GUDY',
    potentialAction: {
      '@type': 'SearchAction',
      target: `${BASE_URL}/?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const localBusiness = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'GUDY',
    image: LOGO,
    url: BASE_URL,
    telephone: '+91-7373755589',
    address: org.address,
    priceRange: '₹99–₹1499',
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: 'Saturday',
        opens: '09:00',
        closes: '14:00',
      },
    ],
  };

  const productList = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'GUDY Jaggery Products',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'GUDY Jaggery Powder 1KG', url: `${BASE_URL}/product` },
      { '@type': 'ListItem', position: 2, name: 'GUDY Jaggery Powder 3KG', url: `${BASE_URL}/product` },
      { '@type': 'ListItem', position: 3, name: 'GUDY Jaggery Powder 5KG', url: `${BASE_URL}/product` },
      { '@type': 'ListItem', position: 4, name: 'GUDY Jaggery Cubes 1KG',  url: `${BASE_URL}/product` },
      { '@type': 'ListItem', position: 5, name: 'GUDY Jaggery Cubes 3KG',  url: `${BASE_URL}/product` },
      { '@type': 'ListItem', position: 6, name: 'GUDY Jaggery Cubes 5KG',  url: `${BASE_URL}/product` },
    ],
  };

  const breadcrumb = (items) => ({
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map(([name, path], i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name,
      item: `${BASE_URL}${path}`,
    })),
  });

  switch (page) {
    case 'home':
      return [org, website, productList, localBusiness];
    case 'product':
      return [org, productList, breadcrumb([['Home', '/'], ['Products', '/product']])];
    case 'about':
      return [org, breadcrumb([['Home', '/'], ['About Us', '/about']])];
    case 'contact':
      return [org, localBusiness, breadcrumb([['Home', '/'], ['Contact', '/contact']])];
    case 'faq':
      return [org, breadcrumb([['Home', '/'], ['FAQ', '/faq']])];
    case 'distributor':
      return [org, breadcrumb([['Home', '/'], ['Distributor Enquiry', '/distributor']])];
    default: {
      const cfg = SEO_CONFIG[page];
      return [org, breadcrumb([['Home', '/'], [cfg?.h1 || page, `/${page}`]])];
    }
  }
}

// ─── Main hook ────────────────────────────────────────────────────────────────
export function useSEO(page) {
  useEffect(() => {
    const cfg = SEO_CONFIG[page] || SEO_CONFIG['home'];

    // 1. Document title
    document.title = cfg.title;

    // 2. Standard meta tags
    setMeta('meta[name="description"]', 'content', cfg.description);
    setMeta('meta[name="keywords"]',    'content', cfg.keywords || '');
    setMeta('meta[name="robots"]',      'content', 'index, follow');
    setMeta('meta[name="author"]',      'content', 'GUDY');

    // 3. Canonical URL
    setLink('canonical', cfg.canonical);

    // 4. Open Graph
    setMeta('meta[property="og:title"]',       'content', cfg.title);
    setMeta('meta[property="og:description"]', 'content', cfg.description);
    setMeta('meta[property="og:url"]',         'content', cfg.canonical);
    setMeta('meta[property="og:type"]',        'content', cfg.og?.type || 'website');
    setMeta('meta[property="og:image"]',       'content', cfg.og?.image || LOGO);
    setMeta('meta[property="og:site_name"]',   'content', 'GUDY');
    setMeta('meta[property="og:locale"]',      'content', 'en_IN');

    // 5. Twitter Card
    setMeta('meta[name="twitter:card"]',        'content', 'summary_large_image');
    setMeta('meta[name="twitter:title"]',       'content', cfg.title);
    setMeta('meta[name="twitter:description"]', 'content', cfg.description);
    setMeta('meta[name="twitter:image"]',       'content', cfg.og?.image || LOGO);

    // 6. Inject SEO content: H2s, keyword-rich body text + internal nav links
    //    NOTE: H1 is NOT injected here to avoid duplicate H1 errors.
    //    Each page component renders its own visible H1 tag.
    injectSEOContent(cfg.h2s || [], cfg.bodyText || '');

    // 7. Structured data (JSON-LD)
    removeById('ld-json');
    const script = document.createElement('script');
    script.id   = 'ld-json';
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(buildLD(page));
    document.head.appendChild(script);

    return () => {
      removeById('ld-json');
      removeById('seo-headings');
    };
  }, [page]);
}